import styles from './styles.module.scss';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@/app/hooks';
import { selectConfirmModal, setConfirmPath, setShowConfirmLeave } from '@/features/confirmModal/confirmModalSlice';

interface Props {
  title: string;
  path: string;
  id: string;
  onClick?: () => void;
  query?: string;
}

export const NavItem: React.FC<Props> = ({ title, path, id, onClick, query }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { isUserInForm, editedForm } = useAppSelector(selectConfirmModal);

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault();
    if (isUserInForm && editedForm) {
      dispatch(setConfirmPath('/' + path));
      dispatch(setShowConfirmLeave(true));
    } else {
      navigate('/' + path);
    }
    onClick?.();
  };

  return (
    <NavLink
      onClick={handleClick}
      id={`${id}Nav`}
      to={path}
      className={({ isActive }) =>
        [styles.navItem, (query ? location.search.includes(query) : isActive) && styles.navItem_clicked].join(' ')
      }
    >
      <p className='subtitle3'>{title}</p>
    </NavLink>
  );
};
